<template>
  <div id="app" class="mt-16 ml-6" align="center">
    <router-link to="/">
        <v-img 
        src="../assets/InTheSuburbs-small.png"
        href="/"
        max-width="350"
        alt="InTheSuburbs.com.au"
      ></v-img>
      </router-link>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <search />
  </div>
</template>

<script>
  import Search from '../components/Search'

  export default {
    name: 'Home',

    data () {
      return {
        pageTitle: '',
        pageMeta: [],
      }
    },

    components: {
      Search,
    },

  mounted() {
    this.pageTitle = "InTheSuburbs.com.au - Your source of information about Australian suburbs",
    this.pageMeta = [
                    {
                        name: 'description',
                        content: 'Your source of information about Australian suburbs. Demographics, shops, maps and more.'
                    },
                    {
                        property: 'og:description',
                        content: 'Your source of information about Australian suburbs. Demographics, shops, maps and more.'
                    },
                    {
                        property: 'og:type',
                        content: 'website'
                    },
                    {
                        property: 'og:title',
                        content: 'Your source of information about Australian suburbs. Demographics, shops, maps and more.'
                    }
                    ]
  },
  }
</script>
